<div class="tw-min-h-screen tw-flex tw-flex-col tw-w-full" style="background: linear-gradient(135deg, #0052cc 0%, #003d99 50%, #002966 100%);">
  <div class="tw-container tw-mx-auto tw-px-4 tw-py-6 sm:tw-py-8 tw-flex tw-flex-col tw-flex-1">
    
    <!-- Top Navigation (No Criar Conta / Pedir Acesso) -->
    <nav class="tw-flex tw-items-center tw-justify-between tw-mb-6 sm:tw-mb-10">
      <div class="tw-flex tw-items-center tw-gap-3">
        <div class="tw-size-9 sm:tw-size-10 tw-bg-white tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-shrink-0 tw-shadow-sm">
          <svg class="tw-size-5 sm:tw-size-6" viewBox="0 0 24 24" fill="none" stroke="#0052cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="6 9 6 2 18 2 18 9"></polyline>
            <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
            <rect x="6" y="14" width="12" height="8"></rect>
          </svg>
        </div>
        <span class="tw-text-lg sm:tw-text-2xl tw-font-bold !tw-text-white" style="color: #ffffff !important;">Print4You</span>
      </div>
      <div class="tw-flex tw-items-center">
        <span class="tw-text-xs tw-font-semibold !tw-text-white tw-px-3 tw-py-1 tw-rounded-full tw-bg-white/15 tw-tracking-wide" style="color: #ffffff !important;">
          VAULT ENTERPRISE
        </span>
      </div>
    </nav>

    <!-- Main Grid -->
    <div class="tw-flex-1 tw-flex tw-items-center">
      <div class="tw-grid lg:tw-grid-cols-2 tw-gap-6 sm:tw-gap-8 lg:tw-gap-12 tw-w-full tw-items-center">
        
        <!-- Left Hero Column -->
        <div class="tw-hidden lg:tw-block tw-text-white tw-pr-6">
          <h1 class="tw-text-4xl lg:tw-text-5xl tw-font-bold !tw-text-white tw-mb-5 tw-leading-tight" style="color: #ffffff !important;">
            Gestão Profissional de Serviços de Impressão & Credenciais
          </h1>
          <p class="tw-text-base sm:tw-text-lg !tw-text-white/90 tw-mb-8 tw-leading-relaxed" style="color: rgba(255, 255, 255, 0.9) !important;">
            Simplifique o acesso seguro da sua equipa, centralize credenciais corporativas e acompanhe projetos num único cofre protegido.
          </p>

          <div class="tw-flex tw-flex-col tw-gap-5">
            <div class="tw-flex tw-items-start tw-gap-3.5">
              <div class="tw-size-9 tw-rounded-full tw-bg-white/15 tw-flex tw-items-center tw-justify-center tw-shrink-0">
                <i class="bwi bwi-shield tw-text-base !tw-text-white" style="color: #ffffff !important;"></i>
              </div>
              <div>
                <h4 class="tw-text-base tw-font-bold !tw-text-white tw-mb-0.5" style="color: #ffffff !important;">Gestão de Cofres Eficiente</h4>
                <p class="tw-text-sm !tw-text-white/80 tw-mb-0" style="color: rgba(255, 255, 255, 0.8) !important;">Acompanhe todos os acessos da empresa com sistema de permissões e segurança.</p>
              </div>
            </div>

            <div class="tw-flex tw-items-start tw-gap-3.5">
              <div class="tw-size-9 tw-rounded-full tw-bg-white/15 tw-flex tw-items-center tw-justify-center tw-shrink-0">
                <i class="bwi bwi-briefcase tw-text-base !tw-text-white" style="color: #ffffff !important;"></i>
              </div>
              <div>
                <h4 class="tw-text-base tw-font-bold !tw-text-white tw-mb-0.5" style="color: #ffffff !important;">Acompanhamento em Tempo Real</h4>
                <p class="tw-text-sm !tw-text-white/80 tw-mb-0" style="color: rgba(255, 255, 255, 0.8) !important;">Preenchimento automático instantâneo ao abrir os links corporativos.</p>
              </div>
            </div>

            <div class="tw-flex tw-items-start tw-gap-3.5">
              <div class="tw-size-9 tw-rounded-full tw-bg-white/15 tw-flex tw-items-center tw-justify-center tw-shrink-0">
                <i class="bwi bwi-collection-shared tw-text-base !tw-text-white" style="color: #ffffff !important;"></i>
              </div>
              <div>
                <h4 class="tw-text-base tw-font-bold !tw-text-white tw-mb-0.5" style="color: #ffffff !important;">Colaboração em Equipa</h4>
                <p class="tw-text-sm !tw-text-white/80 tw-mb-0" style="color: rgba(255, 255, 255, 0.8) !important;">Atribua coleções, adicione membros e partilhe senhas com segurança.</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Right Solid Pure White Card -->
        <div class="tw-flex tw-justify-center lg:tw-justify-end">
          <div class="p4y-auth-card tw-w-full tw-max-w-md tw-bg-white tw-rounded-2xl tw-shadow-2xl tw-p-6 sm:tw-p-8 tw-border tw-border-solid tw-border-[#e9ecef]" style="background-color: #ffffff !important; color: #212529 !important;">
            <h2 class="tw-text-xl sm:tw-text-2xl tw-font-bold tw-text-[#212529] tw-mb-5 sm:tw-mb-6" style="color: #212529 !important;">
              {{ title() || 'Iniciar Sessão' }}
            </h2>

            <ng-container *ngTemplateOutlet="defaultContent"></ng-container>
          </div>
        </div>

      </div>
    </div>

    <!-- Bottom Footer -->
    <footer class="tw-py-4 tw-text-center tw-text-xs !tw-text-white/60" style="color: rgba(255, 255, 255, 0.6) !important;">
      © {{ year }} Print4You • Prolink Digital • Todos os direitos reservados.
    </footer>
  </div>
</div>

<ng-template #defaultContent>
  <ng-content></ng-content>
</ng-template>
